/*  IL COLORE DI UNO STATO.

    In griglia lo stato arriva come testo — «Non aggiudicato» — perche' la vista lo
    traduce in SQL; nelle schede arriva come nome dell'enumerazione — «NonAggiudicato».
    Sono la stessa cosa e devono avere lo stesso colore, quindi la chiave si normalizza:
    minuscole, via spazi e accenti.

    I toni sono quattro e sono gia' quelli del ciclo di vita del preventivo, che li usa
    dal 05/09: chi guarda l'elenco e poi apre la scheda deve trovare lo stesso verde.

      neutro   il documento e' ancora in mano nostra e non e' successo niente
      attesa   e' uscito, e la palla ce l'ha il cliente
      buono    ha prodotto quello per cui esisteva
      spento   e' chiuso senza risultato: non c'e' niente da farci
      critico  e' finito male, o non esiste piu'

    «Non aggiudicato» e' spento e non critico di proposito: un preventivo perso e' un
    esito normale del mestiere, e colorarlo di rosso vorrebbe dire dipingere di sangue
    meta' elenco di chiunque faccia offerte. Spento e non neutro perche' scorrendo
    l'elenco una bozza e un'offerta persa sono due cose opposte — su una si lavora,
    l'altra si salta — e in grigio identico si confondono.  */
export type TonoStato = 'neutro' | 'attesa' | 'buono' | 'spento' | 'critico';

const TONI: Record<string, TonoStato> = {
  bozza: 'neutro',
  inredazione: 'neutro',
  nonaggiudicato: 'spento',
  scaduto: 'spento',
  chiuso: 'spento',
  inviato: 'attesa',
  inviata: 'attesa',
  inattesa: 'attesa',
  confermato: 'buono',
  confermata: 'buono',
  /*  «Confermato in parte» e' verde come «Confermato», perche' e' la stessa cosa: il
      cliente ha detto di si'. Che ne abbia preso meta' lo dice la parola, e dipingerlo
      d'ambra lo farebbe leggere come un problema aperto — non lo e', e' un lavoro
      acquisito piu' piccolo di quello offerto.  */
  confermatoinparte: 'buono',
  registrato: 'buono',
  approvato: 'buono',
  annullato: 'critico',
  annullata: 'critico',
  respinto: 'critico',

  /*  LE CONSEGNE, aggiunte il 20/09/2026 per il punto 8 della riunione: «ritardo rosso,
      ricevuto verde». Sono gli stati di un ordine fornitore, e cadono nella stessa scala
      senza aggiungerne una seconda.

      «Attesa» non e' qui apposta: cade nel neutro, e il neutro e' quello che vuole. Un
      ordine appena partito da cui non e' ancora arrivato niente non e' un problema, e
      dipingerlo d'ambra come «Parziale» farebbe sembrare in ritardo mezza pagina di
      ordini regolarissimi. Il ritardo e' un'altra cosa, ha il suo campo e il suo rosso.  */
  completa: 'buono',
  parziale: 'attesa',
  chiusa: 'spento',
  inritardo: 'critico',
  // Gli scontrini dei tecnici caldaie (23/10/2026).
  emesso: 'buono',
  daemettere: 'attesa',
  daverificare: 'critico',
};

export function tonoStato(valore: string): TonoStato {
  return TONI[chiave(valore)] ?? 'neutro';
}

/*  «Non aggiudicato», «NonAggiudicato» e «non aggiudicato» sono la stessa chiave. Gli
    accenti si tolgono con la scomposizione unicode: «Annullata` con l'accento non
    esiste oggi, ma la prossima parola italiana che arriva qui ce l'avra'.  */
function chiave(valore: string): string {
  return valore
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');
}
